const spinner = document.getElementById('spinner');
const makeString = `${url}/makes?subscription-key=${key}`;
const regoFilters = document.getElementById('rego-filters');
const rego = document.getElementById('rego');
const regoSearch = document.getElementById('regoSearch');
const states = document.getElementById('states');
const sbr = document.getElementById('sbr');
const vehicleFilters = document.getElementById('vehicle-filters');
const make = document.getElementById('makes');
const year = document.getElementById('years');
const model = document.getElementById('models');
const series = document.getElementById('series');
const lookup = document.getElementById('lookup');
const sbv = document.getElementById('sbv');
const tyreFilters = document.getElementById('tyre-search');
const sbw = document.getElementById('sbw');
const wheelFilters = document.getElementById('wheel-search');
const sbt = document.getElementById('sbt');
const searchContainer = document.getElementById('searchContainer');

//function for rego use vehicle selector instead button
document.getElementById('choose').addEventListener('click', function () {
    if (!sbv.classList.value.includes('switchActive')) {
        regoFilters.style.display = 'none';
        vehicleFilters.style.display = 'block';
        setTimeout(() => {
            regoFilters.style.opacity = 0;
        }, this.animationDelay + 10);
        setTimeout(() => {
            vehicleFilters.style.opacity = 1;
        }, this.animationDelay + 20);
        sbr.classList.toggle('switchActive');
        sbv.classList.toggle('switchActive');
        sbr.classList.toggle('switchOff');
        sbv.classList.toggle('switchOff');
    }
});

//load data for dropdowns and check for locally stored selection data
document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('vehicle-filters')) {
        if (localStorage.getItem('makeList')) {
            make.innerHTML = localStorage.getItem('makeList');
            make.disabled = false;
            if (localStorage.getItem('makeSelection')) {
                make.selectedIndex = localStorage.getItem('makeSelection');
                makeMove(make, year, model, series, lookup, spinner);
            }
        } else {
            retrieveMakes(makeString, options, spinner, make);
        }

        //listen for inputs on dropboxes
        make.addEventListener('input', function () {
            storageWiper(6);
            dropDownSwitches(3, series, model, year);
            makeMove(make, year, model, series, lookup, spinner);
        });

        year.addEventListener('input', function () {
            storageWiper(4);
            dropDownSwitches(2, series, model, year);
            yearMove(model, series, lookup, year, make, spinner);
        });

        model.addEventListener('input', function () {
            storageWiper(2);
            dropDownSwitches(1, series, model, year);
            modelMove(series, lookup, model, year, spinner);
        });

        series.addEventListener('input', function () {
            seriesMove(series, lookup);
        });

        //listen for click on search
        lookup.addEventListener('click', function () {
            let vehicleID = series.value;
            let reqString = `${url}/fitments/${vehicleID}?subscription-key=${key}`;
            localStorage.setItem('makeSelection', make.selectedIndex);
            localStorage.setItem('yearSelection', year.selectedIndex);
            localStorage.setItem('modelSelection', model.selectedIndex);
            localStorage.setItem('seriesSelection', series.selectedIndex);
            searchVehicle(reqString, options, vehicleID, '', spinner, make, year, model, series, sbv);
        });
    }
});
document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('rego-filters')) {
        if (localStorage.getItem('regoString')) {
            rego.value = localStorage.getItem('regoString');
            states.disabled = false;
            if (localStorage.getItem('regoState')) {
                states.selectedIndex = localStorage.getItem('regoState');
                stateActive(regoSearch,spinner,rego,states,sbr, make,year,model,series, sbv);
            }
        }
        //listener for rego and states inputs to enable/disable inputs and search button
        rego.addEventListener('input', function () {
            if (rego.value.length > 0) {
                states.disabled = false;
            } else if (rego.value.length == 0) {
                states.disabled = true;
                states.selectedIndex = 0;
                regoSearch.style.cursor = 'none';
                regoSearch.style.opacity = '0.8';
                regoSearch.disabled = true;
            }
        });

        states.addEventListener('input', function () {
            if (states.value.length > 0) {
                stateActive(regoSearch,spinner,rego,states,sbr, make,year,model,series, sbv);
            } else if (states.value.length == 0) {
                regoSearch.style.cursor = 'none';
                regoSearch.style.opacity = '0.8';
                regoSearch.disabled = true;
                regoSearch.removeEventListener('click', function() {
                    searchRego(spinner,rego,states,sbr, make,year,model,series, sbv);
                });
            }
        });
    }
});

//listeners to switch between search tabs
function changeTabs(X, Y) {
    if (X) {
        X.addEventListener('click', function () {
            if (!X.classList.value.includes('switchActive') || window.getComputedStyle(Y).getPropertyValue('height') == '0px') {
                Y.style.display = 'block';
                if (vehicleFilters && X != sbv) {
                    vehicleFilters.style.display = 'none';
                    setTimeout(() => {
                        vehicleFilters.style.opacity = 0;
                    }, this.animationDelay + 10);
                    if (sbv.classList.value.includes('switchActive')) {
                        sbv.classList.toggle('switchActive');
                        sbv.classList.toggle('switchOff');
                    }
                }
                if (regoFilters && X != sbr) {
                    regoFilters.style.display = 'none';
                    setTimeout(() => {
                        regoFilters.style.opacity = 0;
                    }, this.animationDelay + 10);
                    if (sbr.classList.value.includes('switchActive')) {
                        sbr.classList.toggle('switchActive');
                        sbr.classList.toggle('switchOff');
                    }
                }
                if (tyreFilters && X != sbt) {
                    tyreFilters.style.display = 'none';
                    setTimeout(() => {
                        tyreFilters.style.opacity = 0;
                    }, this.animationDelay + 10);
                    if (sbt.classList.value.includes('switchActive')) {
                        sbt.classList.toggle('switchActive');
                        sbt.classList.toggle('switchOff');
                    }
                }
                if (wheelFilters && X != sbw) {
                    wheelFilters.style.display = 'none';
                    setTimeout(() => {
                        wheelFilters.style.opacity = 0;
                    }, this.animationDelay + 10);
                    if (sbw.classList.value.includes('switchActive')) {
                        sbw.classList.toggle('switchActive');
                        sbw.classList.toggle('switchOff');
                    }
                }
                setTimeout(() => {
                    Y.style.opacity = 1;
                }, this.animationDelay + 20);
                X.classList.toggle('switchActive');
                X.classList.toggle('switchOff');
            }
        });
    }
}

changeTabs(sbv, vehicleFilters);
changeTabs(sbr, regoFilters);
changeTabs(sbt, tyreFilters);
changeTabs(sbw, wheelFilters);